"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackWebVitals = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackWebVitals(webvitals) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'WEBVITALS',
        webvitals,
    });
}
exports.trackWebVitals = trackWebVitals;
//# sourceMappingURL=trackWebVitals.js.map